import { Authenticator, AuthenticatorType, setAuthenticator } from '@ms/yammer-web-authenticators';
import { getNetworkContext } from '@ms/yammer-web-support/dist/location';

import config from '../config';

import { reportAuthError } from './reportAuthError';

const getAuthenticator = async () => {
  const networkContext = getNetworkContext(window.location.pathname);
  let tenant = config.msal.tenant;
  if (networkContext?.networkType === 'Canonical') {
    tenant = networkContext.permalink;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (config as any).adal = config.msal;
  const { default: MsalRedirectAuthenticator } = await import(
    /* webpackChunkName: "4-auth-msal" */ '@ms/yammer-web-authenticators/dist/redirect/MsalRedirectAuthenticator'
  );

  return new MsalRedirectAuthenticator({ ...config.msal, tenant, onError: reportAuthError });
};

export type SetupAuthenticator = () => ReturnType<typeof getAuthenticator>;
export const setupAuthenticator: SetupAuthenticator = async () => {
  const authenticator = await getAuthenticator();

  setAuthenticator(authenticator);

  return authenticator;
};

// export type SetupAuthenticator = () => Promise<Authenticator>;
// export const setupAuthenticator: SetupAuthenticator = async () => {
//   const authenticator = await getAuthenticator();
//   // const authenticator = new EnvVarAuthenticator();
//   setAuthenticator(authenticator);

//   return authenticator;
// };

// eslint-disable-next-line @typescript-eslint/no-unused-vars
class EnvVarAuthenticator implements Authenticator {
  public readonly type = AuthenticatorType.Custom;
  public acquireToken(): Promise<string> {
    return Promise.resolve(process.env.TOKEN || '');
  }
  public acquireTokenRedirect(): never {
    throw new Error('Method not implemented.');
  }
  public setThirdPartyCookieErrorCallback(): never {
    throw new Error('Method not implemented.');
  }
}
